/**
 * Monolith 3D Icon Custom Cursor & Dynamic Click Animations
 */
export function initMonolithCursor() {
  // Only activate on pointer-fine desktop devices
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  // Create cursor elements
  const cursor = document.createElement('div');
  cursor.className = 'monolith-cursor';
  
  const icon = document.createElement('div');
  icon.className = 'monolith-cursor-icon';
  cursor.appendChild(icon);
  document.body.appendChild(cursor);

  let mouseX = window.innerWidth / 2;
  let mouseY = window.innerHeight / 2;
  let cursorX = mouseX;
  let cursorY = mouseY;
  let isMoving = false;

  // Smooth position tracking with requestAnimationFrame
  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;

    if (!isMoving) {
      cursor.style.opacity = '1';
      isMoving = true;
    }
  });

  window.addEventListener('mouseleave', () => {
    cursor.style.opacity = '0';
  });

  window.addEventListener('mouseenter', () => {
    cursor.style.opacity = '1';
  });

  function renderCursor() {
    // Smooth lerp follow
    cursorX += (mouseX - cursorX) * 0.28;
    cursorY += (mouseY - cursorY) * 0.28;

    cursor.style.transform = `translate3d(${cursorX}px, ${cursorY}px, 0) translate(-50%, -50%)`;
    requestAnimationFrame(renderCursor);
  }
  requestAnimationFrame(renderCursor);

  // Interactive element hover detection
  const interactiveSelectors = 'a, button, input, select, textarea, [role="button"], .tilt-card, .btn, .umbrella-tab-btn, .filter-btn, .host-plan-tab';
  
  document.addEventListener('mouseover', (e) => {
    if (e.target.closest(interactiveSelectors)) {
      cursor.classList.add('is-hovering');
    }
  });

  document.addEventListener('mouseout', (e) => {
    if (e.target.closest(interactiveSelectors)) {
      cursor.classList.remove('is-hovering');
    }
  });

  // Mouse down: charging compression
  window.addEventListener('mousedown', () => {
    cursor.classList.add('is-pressed');
  });

  window.addEventListener('mouseup', () => {
    cursor.classList.remove('is-pressed');
  });

  // Click animation: 3D barrel roll + shockwave ripple + sparkle burst
  window.addEventListener('click', (e) => {
    // 1. Trigger 3D spin animation
    cursor.classList.remove('is-clicked');
    // Force reflow
    void cursor.offsetWidth;
    cursor.classList.add('is-clicked');

    setTimeout(() => {
      cursor.classList.remove('is-clicked');
    }, 600);

    // 2. Spawn golden expanding shockwave ripple
    spawnClickRipple(e.clientX, e.clientY);

    // 3. Spawn golden sparks burst
    spawnSparks(e.clientX, e.clientY);
  });
}

function spawnClickRipple(x, y) {
  const ripple = document.createElement('div');
  ripple.className = 'cursor-click-ripple';
  ripple.style.left = `${x}px`;
  ripple.style.top = `${y}px`;
  document.body.appendChild(ripple);

  ripple.addEventListener('animationend', () => {
    ripple.remove();
  });
}

function spawnSparks(x, y) {
  const count = 7;
  for (let i = 0; i < count; i++) {
    const spark = document.createElement('div');
    spark.className = 'cursor-spark';
    spark.style.left = `${x}px`;
    spark.style.top = `${y}px`;

    const angle = (i / count) * (Math.PI * 2) + (Math.random() * 0.4 - 0.2);
    const distance = 30 + Math.random() * 35;
    const tx = Math.cos(angle) * distance;
    const ty = Math.sin(angle) * distance;

    spark.style.setProperty('--tx', `${tx}px`);
    spark.style.setProperty('--ty', `${ty}px`);

    document.body.appendChild(spark);

    spark.addEventListener('animationend', () => {
      spark.remove();
    });
  }
}

